import React, { useState } from 'react';
import { Container, Typography, Accordion, AccordionSummary, AccordionDetails, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FAQPage = () => {
  const faqData = [
    { question: "What is InkedUp Manager?", answer: "InkedUp Manager is a tattoo studio management tool designed to streamline appointment scheduling, client management, consent forms, and inventory tracking." },
    { question: "Is InkedUp Manager free to use?", answer: "We offer different pricing plans based on studio needs. Visit our pricing page for more details." },
    { question: "How do I update my account information?", answer: "Navigate to the Settings page to update your name, email, and other personal details." },
    { question: "How do I book a new appointment?", answer: "Go to the Appointments page, select a client, choose a date and time, and save the appointment." },
    { question: "How secure is my data?", answer: "We use industry-standard encryption and security measures to protect your data." },
    { question: "How do I contact support?", answer: "You can reach us via email at support@inkedupmanager.com or visit the Support Page." }
  ];

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>Frequently Asked Questions</Typography>
        <Typography variant="subtitle1" color="textSecondary">
          Have questions? Check below for some commonly asked questions and answers.
        </Typography>
      </Box>

      {faqData.map((faq, index) => (
        <Accordion key={index} sx={{ mt: 2 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">{faq.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>{faq.answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Container>
  );
};

export default FAQPage;
